import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { InvitationResponse } from '../models/invitation.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

@Injectable({ providedIn: 'root' })
export class InvitationDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean }>({ isOpen: false });
  private readonly saved$$ = new Subject<InvitationResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false });
  }

  notifySaved(invitation: InvitationResponse): void {
    this.saved$$.next(invitation);
  }
}
